import { render, staticRenderFns } from "./RegisterInfo.vue?vue&type=template&id=48ccb564&scoped=true&"
import script from "./RegisterInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ccb564",
  null
  
)

export default component.exports